import { request } from "../utils/api";

export const GetRules = (id) => {
  return request({
    method: "get",
    baseUrl: "api",
    route: `promocao-regulamento/${id}`,
  });
};
